import { render, staticRenderFns } from "./PriorRequest.vue?vue&type=template&id=35ebf43c&"
import script from "./PriorRequest.vue?vue&type=script&lang=js&"
export * from "./PriorRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports